/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { compareDependencies } from './dependenciesCompare.generated.js';
import { isNaNDependencies } from './dependenciesIsNaN.generated.js';
import { isNumericDependencies } from './dependenciesIsNumeric.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createPartitionSelect } from '../../factoriesAny.js';
export var partitionSelectDependencies = {
  compareDependencies,
  isNaNDependencies,
  isNumericDependencies,
  typedDependencies,
  createPartitionSelect
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesPartitionSelect.generated.js
// module id = 369
// module chunks = 2